import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import localeStub from '../lib/localeStub';

// initial config data for refund tracker
const initialState = {
  country: 'US',
  locale: 'en_US',
  localeBundle: null,
  timeZone: 'Etc/UTC',
  user: null,
  remoteConfigs: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.BUNDLE_SETTING: {
      const country = _get(action, 'payload.country', initialState.country);
      const locale = _get(action, 'payload.locale', initialState.locale);
      const timeZone = _get(action, 'payload.timeZone', initialState.timeZone);
      const remoteConfigs = _get(action, 'payload.remoteConfigs', initialState.remoteConfigs);

      return {
        ...state,
        country,
        locale,
        localeBundle: localeStub()[locale],
        timeZone,
        remoteConfigs,
      };
    }

    case types.USER_SETTING:
      return { ...state, user: action.payload };
    default:
      return state;
  }
}
